import { eras } from "@/mocks/films";

export default function NostalgiaTimeline() {
  return (
    <section id="eras" className="w-full bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-5xl mx-auto">
          <header className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
              <i className="ri-history-line" aria-hidden="true"></i>
              怀旧剧场 · 年代脉络
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
              从奠定到重看，四个年代的四口气质
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              把老电影放回它诞生的时间线上，会更容易理解为什么同一套动作语言在不同年代看起来并不一样。
              下面四个阶段可以当作怀旧剧场观看的心智地图。
            </p>
          </header>

          <ol className="relative mt-10 md:mt-14 pl-8 md:pl-0">
            <span className="absolute left-[7px] md:left-1/2 top-1 bottom-1 w-px md:-translate-x-1/2 bg-background-300"></span>
            {eras.map((era, index) => {
              const isLeft = index % 2 === 0;
              return (
                <li key={era.id} className="relative mb-8 md:mb-12 last:mb-0 md:grid md:grid-cols-2 md:gap-10">
                  <span className="absolute left-[-25px] md:left-1/2 top-2 w-3.5 h-3.5 rounded-full bg-accent-500 ring-4 ring-accent-100 md:-translate-x-1/2"></span>

                  <div className={`md:col-span-1 ${isLeft ? "md:pr-10 md:text-right" : "md:col-start-2 md:pl-10"}`}>
                    <div className="inline-flex items-center rounded-md bg-accent-100 text-accent-900 px-3 py-1 text-xs md:text-sm font-label whitespace-nowrap">
                      {era.range}
                    </div>
                    <h3 className="mt-3 font-heading text-lg md:text-2xl font-bold text-foreground-950 leading-snug">
                      {era.title}
                    </h3>
                    <p className="mt-3 text-sm md:text-[15px] text-foreground-600 leading-relaxed">{era.desc}</p>
                    <ul className={`mt-3 flex flex-wrap gap-2 ${isLeft ? "md:justify-end" : ""}`}>
                      {era.marks.map((mark) => (
                        <li
                          key={mark}
                          className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-[11px] md:text-xs font-label"
                        >
                          {mark}
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}